import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const TEAM_REPORT: AppRouteRecordRaw = {
  path: '/team-report',
  name: 'team-report',
  component: DEFAULT_LAYOUT,
  redirect: '/team-report/report',
  meta: {
    locale: 'menu.teamReport',
    requiresAuth: true,
    icon: 'icon-file',
    order: 5,
    hideChildrenInMenu: true,
    activeMenu: 'team-report',
  },
  children: [
    {
      path: 'report',
      name: 'TeamReport',
      component: () => import('@/views/report/teamReport.vue'),
      meta: {
        locale: 'menu.teamReport',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default TEAM_REPORT;
